import React, { useState, useContext } from 'react';
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import AppDrawer from "../AppDrawer/AppDrawer";
import { UserContext } from "../../context/userContext";
import { AccountContext } from "../../context/accountContext";
import { Box, Fab, IconButton, Tooltip, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import AddIcon from "@mui/icons-material/Add";
import AddFamily from "./AddFamily";
import DeleteIcon from "@mui/icons-material/Delete";
import { AuthContext } from "../../context/authContext";
import frugalServicesClient from "../../utils/frugal-services-client";

export default function AccountFamily() {
    const { setPasswordExpired } = useContext(AuthContext);
    const { user } = useContext(UserContext);
    const { accountFamily, setAccountFamilyLoading } = useContext(AccountContext);
    const [openNewFamilyMemberModal, setOpenNewFamilyMemberModal] = useState(false);
    const [openConfirmDeleteDialog, setOpenConfirmDeleteDialog] = useState(false);
    const [memberToDelete, setMemberToDelete] = useState(null);

    const handleOpenNewFamilyMemberModal = () => setOpenNewFamilyMemberModal(true);
    const handleCloseNewFamilyMemberModal = () => {
        setOpenNewFamilyMemberModal(false);
    };

    const handleOpenConfirmDeleteDialog = (member) => {
        setMemberToDelete(member);
        setOpenConfirmDeleteDialog(true);
    };

    const handleCloseConfirmDeleteDialog = () => {
        setMemberToDelete(null);
        setOpenConfirmDeleteDialog(false);
    };

    const addFamilyMember = (name) => {
        frugalServicesClient.addFamilyMember(user?.accountId, name)
        .then(response => {
            if (response.status === 401) {
                setPasswordExpired(true);
            }
            setAccountFamilyLoading(true);
            handleCloseNewFamilyMemberModal();
        }).catch(error => {
            console.error('Request failure: ', error);
        });
    };

    function deleteFamilyMember() {
        if (!memberToDelete) return;

        (async () => {
            const response = await frugalServicesClient.deleteFamilyMember(memberToDelete.id);
            if (response.status === 401) {
                setPasswordExpired(true);
            }
            setAccountFamilyLoading(true);
            handleCloseConfirmDeleteDialog();
        })();
    }

    return (
        <Box sx={{ display: 'flex', paddingTop: '64px' }}>
            <AppDrawer />
            <Paper sx={{ p: 3, width: '100%', flexGrow: 1, m: 2 }}>
                <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 3 }}>
                    <Grid>
                        <Typography variant="h4" gutterBottom>Manage Budget Family</Typography>
                    </Grid>
                    <Grid>
                        <Tooltip title="Add Family Member">
                            <Fab variant="extended" onClick={handleOpenNewFamilyMemberModal} color="secondary" aria-label="add">
                                <AddIcon sx={{ mr: 1 }} />
                                Family Member
                            </Fab>
                        </Tooltip>
                    </Grid>
                </Grid>

                <TableContainer component={Paper} variant="outlined">
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>First Name</TableCell>
                                <TableCell>Role</TableCell>
                                <TableCell align="right">Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {accountFamily.map((row) => (
                                <TableRow key={row.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <TableCell component="th" scope="row">{row.firstName}</TableCell>
                                    <TableCell>{row.role}</TableCell>
                                    <TableCell align="right">
                                        {row.role === "Member" && (
                                            <Tooltip title="Delete Member">
                                                <IconButton aria-label="delete" onClick={() => handleOpenConfirmDeleteDialog(row)} color="error">
                                                    <DeleteIcon />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Paper>
            <AddFamily
                open={openNewFamilyMemberModal}
                closeHandler={handleCloseNewFamilyMemberModal}
                onSave={addFamilyMember}
            />
            <Dialog
                open={openConfirmDeleteDialog}
                onClose={handleCloseConfirmDeleteDialog}
            >
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this user? Existing transactions linked to this user will default to an unknown user.
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseConfirmDeleteDialog}>Cancel</Button>
                    <Button onClick={deleteFamilyMember} color="error">
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
}
